import {
  DEFAULT_PROFILE_ROLE_TYPE,
  normalizeProfileRoleType as normalizeSharedProfileRoleType,
  type ProfileRoleTypeValue,
} from '@nx/shared';
import { isPartnerRole, type PartnerRole } from '../auth/roles';
import type { ProfileRoleType } from './Profile';

export { DEFAULT_PROFILE_ROLE_TYPE };

/** Derive profile roleType from the authenticated user's partnerRole. */
export function profileRoleFromPartnerRole(
  partnerRole: PartnerRole | null | undefined,
): ProfileRoleType {
  if (partnerRole && isPartnerRole(partnerRole)) {
    return partnerRole;
  }
  return DEFAULT_PROFILE_ROLE_TYPE;
}

/** Normalize Firestore roleType values (supports legacy snake_case). */
export function normalizeProfileRoleType(raw: unknown): ProfileRoleType {
  return normalizeSharedProfileRoleType(raw) as ProfileRoleType;
}

export function profileRoleTypesEqual(
  a: ProfileRoleType | unknown,
  b: ProfileRoleType,
): boolean {
  return normalizeProfileRoleType(a) === b;
}

export type { ProfileRoleTypeValue };
